import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import PropTypes from 'prop-types'
import JhtIcon from '../icons/JhtIcon'

class BreadCrumb extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
    }
  }

  componentDidMount() {
    const { category } = this.props
    // SCHEDULEはTOUR APIを利用
    let updatedCategory = category
    if (category === 'schedule' || category === 'alltimeschedule') {
      updatedCategory = 'tour'
    }
    let endPoint
    if (updatedCategory === 'tour') {
      // endPoint = '/data/tour.json'
      endPoint = 'https://mk-official-data.firebaseio.com/tour.json'
    } else {
      // endPoint = '/data/topics.json'
      endPoint = 'https://mk-official-data.firebaseio.com/topics.json'
    }
    axios.get(endPoint).then(result => {
      this.setState({ data: result.data })
    })
  }

  render() {
    const {
      state: { data },
      props: { location },
    } = this
    const splitPath = location.pathname.split('/').filter(e => e !== '')
    return (
      <Breadcrumbs
        className="breadCrumb"
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <Link color="inherit" href="/">
          HOME
        </Link>
        {splitPath.map((element, i) => {
          if (i + 1 >= splitPath.length) {
            if (i === 0) {
              let categoryName = element.toUpperCase()
              if (categoryName === 'ALLTIMESCHEDULE')
                categoryName = 'ALL TIME SCHEDULE'
              if (categoryName === 'WORLDMAP') categoryName = 'WORLD MAP'
              return (
                <Typography key={element} color="textPrimary">
                  {categoryName}
                </Typography>
              )
            }
            const matchData = Array.from(data).filter(e => e.slug === element)
            if (matchData[0]) {
              return (
                <div key={element}>
                  {matchData[0].title.startsWith('JHT') ? (
                    <Typography
                      className="withIcon"
                      key={element}
                      color="textPrimary"
                    >
                      <JhtIcon />
                      <span>{matchData[0].title.substr(3)}</span>
                    </Typography>
                  ) : (
                    <Typography key={element} color="textPrimary">
                      {matchData[0].title}
                    </Typography>
                  )}
                </div>
              )
            }
            return null
          }
          let categoryName = element.toUpperCase()
          if (categoryName === 'ALLTIMESCHEDULE')
            categoryName = 'ALL TIME SCHEDULE'
          return (
            <Link key={element} color="inherit" href={`/${element}`}>
              {categoryName}
            </Link>
          )
        })}
      </Breadcrumbs>
    )
  }
}

export default withRouter(BreadCrumb)

BreadCrumb.propTypes = {
  category: PropTypes.string,
  location: PropTypes.object,
}
BreadCrumb.defaultProps = {
  category: null,
  location: null,
}
